import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=f1675272&"
import script from "./checkbox-group.vue?vue&type=script&lang=js&"
export * from "./checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1675272')) {
      api.createRecord('f1675272', component.options)
    } else {
      api.reload('f1675272', component.options)
    }
    module.hot.accept("./checkbox-group.vue?vue&type=template&id=f1675272&", function () {
      api.rerender('f1675272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/checkbox-group/src/checkbox-group.vue"
export default component.exports